import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import contract from "../../api/contract";
import Notification from "../../components/Notification";
import ModalCustom from "../../components/ModalCustom/ModalCustom";
import { useSearchParams } from "react-router-dom";
import Sign from "./Sign";

// Dùng worker từ CDN, đúng version với lib đang import
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

// Hoặc nếu bạn thích dùng PUBLIC_URL:
/// pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

// data:application/pdf;base64,... -> Uint8Array

const SingByCustomer = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("contractInstanceId");
  const [reuireOPT, setRequireOPT] = useState(false);
  const [seconds, setSeconds] = useState(false);
  const [token, setToken] = useState(null);
  const [formRequireOPT] = Form.useForm();
  const [formVerifyOPT] = Form.useForm();
  const [fileUrl, setFileUrl] = useState(false);

  const [loading, setLoading] = useState(false);

  const contractByCustomer = useRef();

  const handleGetOPT = async () => {
    try {
      const values = await formRequireOPT.validateFields();
      await contract.requestOPT({
        contractInstanceId: id,
        ...values,
      });
      setRequireOPT(true);
      setSeconds(45);
    } catch (error) {
      Notification("error", error?.response?.data?.message ?? "Đã xảy ra lỗi");
    }
  };
  const handleVerifyOPT = async () => {
    setLoading(true);
    try {
      const values = await formVerifyOPT.validateFields();
      const res = await contract.verifyOPT({
        contractInstanceId: id,
        email: formRequireOPT.getFieldValue("email"),
        ...values,
      });
      setToken(res.data.token);
      localStorage.setItem("token", res.data.token);
      formRequireOPT.resetFields();
      formVerifyOPT.resetFields();
      setLoading(false);
      setRequireOPT(false);
      setSeconds(0);
    } catch (error) {
      console.log("🚀 ~ handleVerifyOPT ~ error:", error);
      setLoading(false);
      Notification("error", error?.response?.data?.message ?? "Đã xảy ra lỗi");
    }
  };

  const showContract = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SSO_URL}/contract-customer/contracts/preview?format=pdf`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // 👈 token ở đây
          },
        },
      );
      const data = await res.json();
      const { base64Content, contentType } = data;
      const fileUrl = `data:${contentType};base64,${base64Content}`;
      setFileUrl(fileUrl);
    } catch (error) {
      setLoading(false);
      console.error("API Error:", error);
      Notification(
        "error",
        error?.response?.data?.message ?? "Đã xảy ra lỗi khi tải hợp đồng",
      );
    }
  };

  useEffect(() => {
    if (token) {
      showContract();
    }

    return;
  }, [token]);

  useEffect(() => {
    if (!fileUrl) return;
    contractByCustomer.current.openModal();
    setLoading(false); // ✅ TẮT loading khi modal đã sẵn sàng
  }, [fileUrl]);

  useEffect(() => {
    if (!reuireOPT) return; // chỉ chạy khi true
    if (seconds === 0) return;
    const timer = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);
  return (
    <Spin spinning={loading}>
      <div className="signByCustomer">
        <h2>Hợp đồng cá nhân</h2>
        <Form form={formRequireOPT}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Vui lòng nhập số  điện thoại!" },
            ]}
          >
            <Input placeholder="Nhập địa chỉ email" />
          </Form.Item>
        </Form>
        <Button type="primary" onClick={handleGetOPT} disabled={seconds}>
          Lấy mã OTP
        </Button>
        {reuireOPT && (
          <Typography.Text type="secondary">
            Lấy lại OTP sau: {seconds}s
          </Typography.Text>
        )}

        {reuireOPT && (
          <div>
            <Form form={formVerifyOPT}>
              <Form.Item
                name="otp"
                rules={[
                  { required: true, message: "Vui lòng nhập số  điện thoại!" },
                ]}
              >
                <Input.OTP length={6} />
              </Form.Item>
            </Form>
            <Row justify={"center"}>
              <Button type="primary" onClick={handleVerifyOPT}>
                Lấy hợp đồng cá nhân
              </Button>
            </Row>
          </div>
        )}
      </div>
      <ModalCustom ref={contractByCustomer} title="Hợp đồng cá nhân">
        <Sign
          id={id}
          fileUrl={fileUrl}
          token={token}
          contractByCustomer={contractByCustomer}
        />
      </ModalCustom>
    </Spin>
  );
};

export default SingByCustomer;
